// removed by extract-text-webpack-plugin
module.exports = {"app":"app--2Ya5b"};


//////////////////
// WEBPACK FOOTER
// ./src/App/App.css
// module id = RrqR
// module chunks = 1